<template>
  <div class="fun_config_dia">
    <el-dialog
      title="报价功能配置"
      :visible="dialogVisible"
      :close-on-click-modal="false"
      width="700px"
      @close="close"
    >
    <GlobalTable
        ref="GlobalTable"
        v-loading="configDiaLoading"
        :columns="configTableColumns"
        :data="configDataList"
        :isPagination="false"
      >
        <el-table-column label="功能情况" slot="functionInfo" align="center">
          <template slot-scope="{ row }">
            <template v-if="row.key === 'nextOrderSort'">
              <div>{{currentMerchant.nextOrderSort =='00' ?'最早加入队列':currentMerchant.nextOrderSort =='01'?'最晚加入队列':'--'}}</div>
              <span class="txt-underline" @click="openExamineNextSortDia">设置</span>
            </template>
            <template v-if="row.key === 'isAlwaysPush'">
              <div>{{currentMerchant.isAlwaysPush?'启用':'禁用'}}</div>
              <span class="txt-underline" @click="openAlwaysPushDia">设置</span>
            </template>
            <template v-if="row.key === 'quotationNotPushed'">
              <el-switch inactive-color="#bebebe" @change="switQuotation" v-model="quotationNotPushed"></el-switch>
            </template>
          </template>
        </el-table-column>
      </GlobalTable>
      <span slot="footer" class="dialog-footer">
        <el-button type="primary" @click.native="close">关闭</el-button>
      </span>
    </el-dialog>
    <el-dialog
      title="抢单顺序设置"
      :visible.sync="nextSortVisible"
      :close-on-click-modal="false"
      width="500px"
      @closed="command = ''"
    >
      <p style="color: #ff8695;font-size: 14px;">说明：抢单顺序即为审单员拿取下一单时的顺序，越早加入队列的订单，审单报价时效会越短</p>
      <el-form label-width="100px">
        <el-form-item label="选择顺序" required>
          <el-radio-group v-model="nextOrderSort">
            <el-radio label="00">最早加入队列</el-radio>
            <el-radio label="01">最晚加入队列</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="谷歌验证码" required>
          <el-input v-model="command" placeholder="请输入谷歌验证码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="nextSortVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="nextSortBtnLoading"
          @click.native="examineNextSortSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <el-dialog
      title="报价消息设置"
      :visible.sync="alwaysPushVisible"
      :close-on-click-modal="false"
      width="500px"
      @closed="command = ''"
    >
      <el-form label-width="95px">
        <div style="margin-bottom: 10px;">
          <el-switch
            v-model="isAlwaysPush"
            active-text="始终推送报价消息">
          </el-switch>
        </div>
        <el-form-item label="消息推送订单范围:" label-width="140px" required v-if="isAlwaysPush">
          <el-radio-group v-model="pushRange">
            <el-radio label="01">全部订单</el-radio>
            <el-radio label="02">满足推送值规则的订单</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item label="谷歌验证码" required>
          <el-input v-model="command" placeholder="请输入谷歌验证码"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="alwaysPushVisible = false">取消</el-button>
        <el-button
          type="primary"
          :loading="alwaysPushBtnLoading"
          @click.native="alwaysPushSure"
          >确定</el-button
        >
      </span>
    </el-dialog>
    <!-- 不推送报价备注 -->
    <el-dialog :title="switQuotationTitle" :visible.sync="switQuotationShow" :close-on-click-modal="false"
      width="500px" @close="switQuotationClose">
      <div style="margin-bottom: 20px;">
        <span style="color: #ff8695;font-size: 14px;">{{ quotationNotPushed?'说明：启用后，该商家报价备注不再推送给门店':'说明：关闭后，该商家报价备注仍可推送给门店' }}</span>
      </div>
      <div class="tip-centent">
        <span>{{ quotationNotPushed?'是否确认开启不推送报价功能？':'是否确认禁用不推送报价功能？' }}</span>
      </div>
      <div class="command">
        <div style="width: max-content">谷歌验证码：</div>
        <el-input v-model="command" placeholder="请输入谷歌动态口令"></el-input>
      </div>
      <span slot="footer" class="dialog-footer">
        <el-button @click.native="switQuotationClose">取消</el-button>
        <el-button type="primary" :loading="switQuotationBtnLoading" @click.native="switQuotationSubmit">确定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import _api from "@/utils/request";
export default {
  props: {
    dialogVisible: {
      type: Boolean,
      default: false,
    },
    currentMerchant: {
        type: Object,
        default: () => {},
    }
  },
  data() {
    return {
      configDiaLoading: false,
      configTableColumns: [
          { label: "功能名称", prop: "configName" },
          { slotName: "functionInfo" },
      ],
      configDataList: [
          {configName: "优先报价顺序",key:'nextOrderSort'},
          {configName: "始终推送报价消息",key:'isAlwaysPush'},
          {configName: "报价备注不推送给门店",key:'quotationNotPushed'},
      ],
      nextSortVisible: false,
      nextOrderSort: "",
      isAlwaysPush: "",
      pushRange: "",
      command: "",
      nextSortBtnLoading: false,
      alwaysPushVisible: false,
      alwaysPushBtnLoading: false,
      //不推送报价备注
      switQuotationTitle: '',
      switQuotationShow: false,
      quotationNotPushed: null,
      switQuotationBtnLoading: false,
    };
  },
  created() {
    this.quotationNotPushed = this.currentMerchant.quotationNotPushed
  },
  methods: {
    close() {
      this.$emit("close");
    },
    // getMerchantInfo() {
    //   this.configDiaLoading = true
    //   _api.getExamineMerchantInfo({id: this.merchantId,}).then(res => {
    //     if(res.code === 1){
    //       this.currentMerchant = res.data
    //       this.configDiaLoading = false
    //     }
    //   });
    // },
    openExamineNextSortDia() {
      this.command = ""
      this.nextOrderSort = this.currentMerchant.nextOrderSort
      this.nextSortVisible = true
    },
    examineNextSortSure() {
      if (!this.command.trim()) {
        return this.$message.error("请输入谷歌验证码!");
      }
      this.nextSortBtnLoading = true
      let params = {
        command: this.command,
        nextOrderSort: this.nextOrderSort,
        merchantId: this.currentMerchant.merchantId
      }
      _api.changeNextOrderSort(params).then(res => {
        if(res.code === 1){
          this.$message.success("操作成功!")
          this.nextSortVisible = false
          this.$emit("setSuccess")
          this.close()
        //   this.getMerchantInfo();
        }
      }).finally(() => {
        this.nextSortBtnLoading = false;
      });
    },
    openAlwaysPushDia() {
      this.command = ""
      this.isAlwaysPush = this.currentMerchant.isAlwaysPush
      this.pushRange = this.currentMerchant.pushRange
      this.alwaysPushVisible = true
    },
    alwaysPushSure() {
      if (!this.command.trim()) {
        return this.$message.error("请输入谷歌验证码!");
      }
      let params = {
        merchantIdList: [this.currentMerchant.merchantId],
        isAlwaysPush: this.isAlwaysPush,
        pushRange: this.pushRange,
        command: this.command,
      };
      this.alwaysPushBtnLoading = true;
      _api
        .openMerchantAlwaysPush(params)
        .then((res) => {
          if (res.code == 1) {
            this.$message.success("操作成功!")
            this.nextSortVisible = false
            this.$emit("setSuccess")
            this.close()
          }
        })
        .finally(() => {
          this.alwaysPushBtnLoading = false;
        });
    },
    switQuotation() {
      this.switQuotationTitle = this.quotationNotPushed ? "启用提示" : "禁用提示";
      this.switQuotationShow = true;
    },
    switQuotationClose() {
      this.command = ""
      this.quotationNotPushed = this.currentMerchant.quotationNotPushed
      this.switQuotationShow = false
    },
    switQuotationSubmit() {
      if (!this.command.trim()) {
        return this.$message.error("请输入谷歌验证码!");
      }
      this.switQuotationBtnLoading = true;
      let params = {
        quotationNotPushed: this.quotationNotPushed,
        merchantId: this.currentMerchant.merchantId,
        command: this.command,
      }
      _api.openMerchantQuotationNotPushed(params).then(res => {
        if(res.code === 1){
         this.$message.success("操作成功!")
            this.switQuotationShow = false
            this.$emit("setSuccess")
            this.close()
        }
      }).finally(() => {
        this.switQuotationBtnLoading = false;
      });
    }
  }
};
</script>

<style lang="scss" scoped>
.fun_config_dia {
  .txt-underline{
    color: #0981FF;
    text-decoration: underline;
    cursor: pointer;
  }
}
.tip-centent {
  font-size: 16px;
  text-align: center;
  margin-bottom: 20px;
}
.command {
  display: flex;
  align-items: center;
  /deep/.el-input {
    width: 300px;
  }
}
</style>
